var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 743.591,
    height: 545.462,
    viewBox: "0 0 743.591 545.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12bff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(-13210.918 712.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13973",
    "data-name": "Path 13973",
    d: "M1043.09,1703.975s.984,15.868,4.054,16.1c.408.03,15.57.03,15.57.03l19.356-.112s-.127-4.664-5.784-5.65-15.128-4.962-18.555-12.44C1054.125,1694.033,1043.09,1703.975,1043.09,1703.975Z",
    transform: "translate(12371.841 -1888.043)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116",
    transform: "translate(13335.08 -451.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13974",
    "data-name": "Path 13974",
    d: "M1014.929,1180.086s8.432,2.166,13.792.551,14.586,1.037,16.071,2.992.94,2.731-1.711,3.406-12.044,4.681-18.216,2.362-14.223-2.4-14.223-2.4Z",
    transform: "translate(-942.055 -1097.44)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13975",
    "data-name": "Path 13975",
    d: "M813.045,951.386s9.473,67.323,25.157,73.354c7.74,2.975,41.943,9.72,52.061,10.4,0,0,2.478-2.011,1.875-10.195,0,0-35.835-13.156-40.926-20.311-7.577-10.648,4.7-43.5-4.8-53.5S820.888,936.83,813.045,951.386Z",
    transform: "translate(-813.045 -941.987)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13976",
    "data-name": "Path 13976",
    d: "M752.814,1514.9v-14.678H729.7a1.137,1.137,0,0,1-1.134-1.134v-2.352a1.137,1.137,0,0,1,1.134-1.134h23.109v-83.558a4.275,4.275,0,0,1,4.263-4.263h4.573a4.276,4.276,0,0,1,4.263,4.263v83.558h23.109a1.137,1.137,0,0,1,1.134,1.134v2.352a1.137,1.137,0,0,1-1.134,1.134H765.913V1514.9c16.72,1.264,30.117,7.283,33.875,15.061H718.939C722.7,1522.188,736.093,1516.168,752.814,1514.9Z",
    transform: "translate(12583.476 -1697.997)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13977",
    "data-name": "Path 13977",
    d: "M799.494,1303.337a118.029,118.029,0,0,0,9.253,13.239c10.181,12.852,21.263,23.449,23.194,33.466a45.367,45.367,0,0,0,1.79,6.411c.806,2.294,1.8,4.707,2.953,7.2,4.32,9.384,10.78,19.9,17.231,29.457,11.151,16.523,21.636,30.311,21.636,30.311l19.23-.82c-.77-1.927-9.157-24.742-20.377-52.622-4.556-11.318-9.4-23.357-14.075-34.967q-.934-2.326-1.862-4.625c-1.429-3.553-2.835-7.051-4.209-10.456-10.535-26.18-18.926-47.026-18.926-47.026s-42.106-15.951-46.479-5.615C785.249,1275.813,788.186,1284.161,799.494,1303.337Z",
    transform: "translate(12538.777 -1603.993)",
    fill: "#e58638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13978",
    "data-name": "Path 13978",
    d: "M891.925,1582.978s-13.375,8.595-12.077,11.386c.172.372,7.564,13.61,7.564,13.61l9.533,16.845s4.01-2.384,2.113-7.805-3.042-15.627,1.817-22.265C905.986,1587.766,891.925,1582.978,891.925,1582.978Z",
    transform: "translate(12478.479 -1812.378)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13979",
    "data-name": "Path 13979",
    d: "M849.57,1268.21s52.851,32.921,58.751,55.045-70.3,69.321-70.3,69.321-8.358-7.375-9.833-12.783c0,0,34.445-41.268,41.917-50.518,4.589-5.682-67.851-19.668-76.7-33.434s-5.681-25.348-5.681-25.348Z",
    transform: "translate(12538.931 -1606.868)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    d: "M11.331,0H104.7a11.331,11.331,0,0,1,11.331,11.331v6.837A11.332,11.332,0,0,1,104.7,29.5H11.332A11.332,11.332,0,0,1,0,18.168V11.331A11.331,11.331,0,0,1,11.331,0Z",
    transform: "translate(13284.822 -296.384)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13980",
    "data-name": "Path 13980",
    d: "M848.385,884.8a29.827,29.827,0,0,1,8.051,7.3c-12.661,3.275-33.651-8.458-33.651-8.458s8.15-5.476,11.169-17.509q.229-.911.415-1.866a38.015,38.015,0,0,0,.686-6.589l5.816,5.21,9.672,8.665a83.062,83.062,0,0,1-1.429,9.779Q848.8,882.945,848.385,884.8Z",
    transform: "translate(12515.675 -1338.831)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13981",
    "data-name": "Path 13981",
    d: "M783.693,983.846c1.814,24.393-1.237,61.477.82,67.9,1.776,5.543,22.672,2.262,30.747.411,2.989-.685,6.61-1.663,10.349-2.82,10.43-3.23,21.794-7.841,23.014-11.265a2.916,2.916,0,0,0,.112-.394,3.133,3.133,0,0,0-.022-1.435c-.407-1.745-1.973-3.633-2.157-7.954-.206-4.824-.175-10.505-.357-16.614-.009-.688-.019-1.438-.093-2.123l0-.25c0-.131-.006-.26-.009-.391-.175-6.813-.531-13.975-.944-21.079-.263-4.461-.566-8.879-.916-13.112-.91-10.927-2.135-20.644-3.758-26.787-2.651-10.014-8.5-16.545-13.819-21.332l-3.848-3.3a22.257,22.257,0,0,1-13.966-1.86c-4.971-2.361-6.687-4.052-7.553-3.414C789.809,926.886,781.552,954.027,783.693,983.846Z",
    transform: "translate(12541.42 -1378.15)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13982",
    "data-name": "Path 13982",
    d: "M869.213,1187.079c10.43-3.23,21.794-7.841,23.014-11.265a2.91,2.91,0,0,0,.112-.394c-.006-.478-.012-.957-.022-1.435-.406-1.745-1.973-3.633-2.157-7.954-.207-4.824-.175-10.505-.357-16.614-.009-.688-.018-1.438-.094-2.123l0-.25c0-.131-.006-.26-.009-.391l-39.4-17.868S848.031,1160.539,869.213,1187.079Z",
    transform: "translate(12497.758 -1515.84)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13983",
    "data-name": "Path 13983",
    d: "M870.454,881.347a83.046,83.046,0,0,1-1.429,9.779c-9.444-3.051-13.728-11.581-15.159-15.2-.407-1.022-.584-1.654-.584-1.654s.367-.079,1-.212c1.327-.283,3.828-.813,6.5-1.378Z",
    transform: "translate(12495.765 -1348.631)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13984",
    "data-name": "Path 13984",
    d: "M869.772,832.484s-20.749,2.34-22.007-10.6-4.784-21.359,8.41-23.4,16.252,2.647,17.723,6.865S875.137,831.542,869.772,832.484Z",
    transform: "translate(12500.27 -1299.864)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13985",
    "data-name": "Path 13985",
    d: "M837.613,807.156s1.316-17.182,20.2-18.961c12.937-1.219,5.724-12.353,4.345-14.129,0,0-9.912,1.359-20.071,3.038C820.766,780.627,835.519,804.481,837.613,807.156Z",
    transform: "translate(12510.511 -1284.246)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(13397.912 -399.933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 1.91,
    height: 50.005,
    transform: "translate(52.462 48.147) rotate(-161.999)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 52.474,
    height: 3.139,
    transform: "translate(52.462 48.147) rotate(-178.776)",
    fill: "#4a75cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(13339.261 -447.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13986",
    "data-name": "Path 13986",
    d: "M1001.044,1209.9s8.142,3.082,13.648,2.068,14.382,2.639,15.643,4.746.634,2.818-2.076,3.2-12.486,3.325-18.365.34-13.872-3.957-13.872-3.957Z",
    transform: "translate(-936.689 -1121.23)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13987",
    "data-name": "Path 13987",
    d: "M825.088,962.278s1.992,67.957,16.917,75.68c7.364,3.811,40.616,14.285,50.6,16.074,0,0,2.685-1.725,2.987-9.926,0,0-34.166-17.027-38.437-24.7-6.357-11.418,9.471-42.717,1.124-53.7S834.488,948.676,825.088,962.278Z",
    transform: "translate(-825.088 -954.439)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 313.053,
    height: 404.457,
    rx: 23,
    transform: "translate(13821.329 -294.49) rotate(180)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 273.06,
    height: 348.23,
    transform: "translate(13801.61 -321.819) rotate(180)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(13549.262 -628.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13988",
    "data-name": "Path 13988",
    d: "M2018.436,843.82h0a14.408,14.408,0,0,1-14.407-14.407V630.22a14.407,14.407,0,0,1,14.407-14.407h0a14.407,14.407,0,0,1,14.407,14.407V829.412A14.407,14.407,0,0,1,2018.436,843.82Z",
    transform: "translate(-1804.81 -552.258)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13989",
    "data-name": "Path 13989",
    d: "M1882.438,724.277h0a14.408,14.408,0,0,1-14.407-14.407V447.122a14.407,14.407,0,0,1,14.407-14.407h0a14.407,14.407,0,0,1,14.407,14.407V709.869A14.408,14.408,0,0,1,1882.438,724.277Z",
    transform: "translate(-1716.018 -432.715)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13990",
    "data-name": "Path 13990",
    d: "M1734.044,947.533h0a14.408,14.408,0,0,1-14.407-14.408V789.072a14.407,14.407,0,0,1,14.407-14.407h0a14.407,14.407,0,0,1,14.407,14.407V933.125A14.408,14.408,0,0,1,1734.044,947.533Z",
    transform: "translate(-1619.133 -655.971)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13991",
    "data-name": "Path 13991",
    d: "M1589.646,797.493h0a14.408,14.408,0,0,1-14.407-14.407V559.264a14.407,14.407,0,0,1,14.407-14.407h0a14.407,14.407,0,0,1,14.407,14.407V783.086A14.408,14.408,0,0,1,1589.646,797.493Z",
    transform: "translate(-1524.857 -505.932)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13992",
    "data-name": "Path 13992",
    d: "M1458.906,886.549V996.767a14.408,14.408,0,0,1-14.407,14.407h0a14.408,14.408,0,0,1-14.407-14.407V886.549a14.407,14.407,0,0,1,14.407-14.407h0A14.407,14.407,0,0,1,1458.906,886.549Z",
    transform: "translate(-1430.091 -719.613)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(13548.943 -646.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13993",
    "data-name": "Path 13993",
    d: "M1574.429,493.452h24.4a2.524,2.524,0,0,1,0,5.049h-24.4a2.524,2.524,0,1,1,0-5.049Z",
    transform: "translate(-1522.361 -454.707)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13994",
    "data-name": "Path 13994",
    d: "M1628.719,519.916h5.558a2.524,2.524,0,0,1,0,5.049h-5.558a2.524,2.524,0,1,1,0-5.049Z",
    transform: "translate(-1557.807 -471.985)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13995",
    "data-name": "Path 13995",
    d: "M1864.118,381.829h24.4a2.524,2.524,0,1,1,0,5.049h-24.4a2.524,2.524,0,0,1,0-5.049Z",
    transform: "translate(-1711.498 -381.829)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13996",
    "data-name": "Path 13996",
    d: "M1918.408,408.293h5.557a2.532,2.532,0,0,1,2.525,2.524h0a2.532,2.532,0,0,1-2.525,2.524h-5.557a2.532,2.532,0,0,1-2.525-2.524h0A2.532,2.532,0,0,1,1918.408,408.293Z",
    transform: "translate(-1746.942 -399.107)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13997",
    "data-name": "Path 13997",
    d: "M2004.721,564.8h24.4a2.524,2.524,0,0,1,0,5.049h-24.4a2.524,2.524,0,1,1,0-5.049Z",
    transform: "translate(-1803.295 -501.292)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13998",
    "data-name": "Path 13998",
    d: "M2059.01,591.268h5.558a2.531,2.531,0,0,1,2.524,2.524h0a2.531,2.531,0,0,1-2.524,2.524h-5.558a2.532,2.532,0,0,1-2.524-2.524h0A2.532,2.532,0,0,1,2059.01,591.268Z",
    transform: "translate(-1838.74 -518.57)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13999",
    "data-name": "Path 13999",
    d: "M1721.244,723.73h24.4a2.524,2.524,0,1,1,0,5.049h-24.4a2.524,2.524,0,0,1,0-5.049Z",
    transform: "translate(-1618.216 -605.053)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14000",
    "data-name": "Path 14000",
    d: "M1775.534,750.194h5.557a2.532,2.532,0,0,1,2.524,2.524h0a2.532,2.532,0,0,1-2.524,2.525h-5.557a2.532,2.532,0,0,1-2.524-2.525h0A2.532,2.532,0,0,1,1775.534,750.194Z",
    transform: "translate(-1653.662 -622.332)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14001",
    "data-name": "Path 14001",
    d: "M1431.7,820.911h24.4a2.525,2.525,0,1,1,0,5.049h-24.4a2.525,2.525,0,0,1,0-5.049Z",
    transform: "translate(-1429.174 -668.502)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14002",
    "data-name": "Path 14002",
    d: "M1485.988,847.375h5.558a2.524,2.524,0,1,1,0,5.049h-5.558a2.524,2.524,0,0,1,0-5.049Z",
    transform: "translate(-1464.62 -685.78)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(13311.019 -546.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14003",
    "data-name": "Path 14003",
    d: "M1454.731,766.49a8.967,8.967,0,1,1,8.967-8.967A8.977,8.977,0,0,1,1454.731,766.49Zm0-14.463a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,1454.731,752.027Z",
    transform: "translate(-1202.082 -721.101)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14004",
    "data-name": "Path 14004",
    d: "M992.559,700.385a1.731,1.731,0,0,1-1.227-.508l-26.948-26.947H745.463a1.736,1.736,0,1,1,0-3.471h220.36l27.963,27.964a1.736,1.736,0,0,1-1.227,2.963Z",
    transform: "translate(-743.727 -669.458)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123",
    transform: "translate(13461.774 -698.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14007",
    "data-name": "Path 14007",
    d: "M1889.049,328.1a8.967,8.967,0,1,1,8.967-8.967A8.977,8.977,0,0,1,1889.049,328.1Zm0-14.463a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,1889.049,313.636Z",
    transform: "translate(-1636.399 -282.71)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14008",
    "data-name": "Path 14008",
    d: "M1426.877,261.994a1.728,1.728,0,0,1-1.227-.508L1398.7,234.539H1179.781a1.736,1.736,0,1,1,0-3.471H1400.14l27.964,27.963a1.736,1.736,0,0,1-1.227,2.963Z",
    transform: "translate(-1178.045 -231.068)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14009",
    "data-name": "Path 14009",
    d: "M891.445,641.349H747.624a4.4,4.4,0,0,1-4.4-4.4h0a4.4,4.4,0,0,1,4.4-4.4H891.445a4.4,4.4,0,0,1,4.4,4.4h0A4.4,4.4,0,0,1,891.445,641.349Z",
    transform: "translate(12567.618 -1191.855)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14010",
    "data-name": "Path 14010",
    d: "M995.908,601.349H907.624a4.4,4.4,0,0,1-4.4-4.4h0a4.4,4.4,0,0,1,4.4-4.4h88.284a4.4,4.4,0,0,1,4.4,4.4h0A4.4,4.4,0,0,1,995.908,601.349Z",
    transform: "translate(12463.156 -1165.74)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14011",
    "data-name": "Path 14011",
    d: "M995.908,561.349H907.624a4.4,4.4,0,0,1-4.4-4.4h0a4.4,4.4,0,0,1,4.4-4.4h88.284a4.4,4.4,0,0,1,4.4,4.4h0A4.4,4.4,0,0,1,995.908,561.349Z",
    transform: "translate(12463.156 -1139.624)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14012",
    "data-name": "Path 14012",
    d: "M1322.87,200.371H1179.049a4.4,4.4,0,0,1-4.4-4.4h0a4.4,4.4,0,0,1,4.4-4.4H1322.87a4.4,4.4,0,0,1,4.4,4.4h0A4.4,4.4,0,0,1,1322.87,200.371Z",
    transform: "translate(12285.944 -903.944)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14013",
    "data-name": "Path 14013",
    d: "M1179.969,1759.12H456.38a1.041,1.041,0,0,1-1.038-1.037h0a1.041,1.041,0,0,1,1.038-1.038h723.589a1.041,1.041,0,0,1,1.037,1.038h0A1.04,1.04,0,0,1,1179.969,1759.12Z",
    transform: "translate(12755.576 -1926.025)",
    fill: "#202f4e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(13742.294 -358.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14014",
    "data-name": "Path 14014",
    d: "M2409.948,1555.845s-13.215-15.418-.814-25.212c0,0,9.058-5.485,16.444-5.04,0,0-10.465,17.551-7.08,19.3s10.253-20.4,10.253-20.4,20.614-2,27.245,1.19c0,0-17.622,14.421-13.911,15.279s22.746-13.3,22.746-13.3,19.185,3.264,18.162,14.969-7.633,15.318-10.539,15.007-19.9-6.8-20.272-4.419,9.861,10.161,17.025,10.525c0,0-13.526,14.917-22.516,10.612s-9.757-11.13-15.361-13.689-10.388-2.552-8.074.058,12.456,5.147,15.66,10.816,6.08,9.491-3.221,8.092-24.419-8.2-25.083-16Z",
    transform: "translate(-2286.625 -1448.452)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14015",
    "data-name": "Path 14015",
    d: "M2467.877,1562.681s-52.109-2.008-63.617,12.894a37.673,37.673,0,0,1-10.377,14.563l-1.22,3.327s9.03-9.52,12.26-10.1C2404.923,1583.369,2399.871,1564.906,2467.877,1562.681Z",
    transform: "translate(-2280.936 -1468.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14016",
    "data-name": "Path 14016",
    d: "M2382.721,1617.405s-11.185,8.272-11.961,23.052l2.03.181s3.572-15.282,10.029-21.259S2382.721,1617.405,2382.721,1617.405Z",
    transform: "translate(-2269.773 -1495.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14017",
    "data-name": "Path 14017",
    d: "M2241.939,1492.948s21.024-11.773,11.212-27.751c0,0-7.848-9.811-16.259-12.334,0,0,4.486,23.827,0,24.387s-3.084-26.91-3.084-26.91-22.145-10.652-30.834-9.811c0,0,13.735,23.266,9.25,22.7s-19.9-24.107-19.9-24.107-22.706-4.205-26.35,9.25,2.243,20.182,5.607,21.023,24.948.561,24.387,3.364-15.137,7.288-23.266,4.766c0,0,8.971,22.145,20.744,21.023s15.418-8.409,22.7-8.97,12.615,1.4,8.971,3.363-15.979.644-21.865,5.648-10.652,8.088.28,10.331,30.555.841,34.479-7.569Z",
    transform: "translate(-2164.823 -1404.946)",
    fill: "#a9dcb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14018",
    "data-name": "Path 14018",
    d: "M2188.318,1467.212s58.866,19.062,65.593,40.365a44.727,44.727,0,0,0,5.607,20.464v4.2s-6.167-14.3-9.531-16.259C2249.988,1515.987,2263.163,1497.487,2188.318,1467.212Z",
    transform: "translate(-2176.797 -1419.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14019",
    "data-name": "Path 14019",
    d: "M2330.591,1588.538s9.078,13.785,3.9,30.566l-2.336-.628s2.268-18.483-2.483-27.779S2330.591,1588.538,2330.591,1588.538Z",
    transform: "translate(-2247.869 -1480.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14020",
    "data-name": "Path 14020",
    d: "M2371.353,1441.834s-27.713-15.519-14.78-36.582c0,0,10.347-12.933,21.431-16.258,0,0-5.912,31.409,0,32.147s4.065-35.472,4.065-35.472,29.191-14.042,40.645-12.933c0,0-18.105,30.669-12.193,29.93s26.234-31.778,26.234-31.778,29.93-5.542,34.734,12.194-2.956,26.605-7.39,27.714-32.886.739-32.147,4.434,19.953,9.607,30.669,6.282c0,0-11.825,29.191-27.344,27.713s-20.322-11.085-29.93-11.824-16.628,1.847-11.825,4.434,21.063.847,28.821,7.444,14.042,10.662-.368,13.618-40.277,1.109-45.45-9.977Z",
    transform: "translate(-2260.791 -1370.068)",
    fill: "#a9dcb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14021",
    "data-name": "Path 14021",
    d: "M2469.073,1407.91s-77.6,25.126-86.465,53.209c0,0,.369,12.563-7.391,26.974v5.542s8.13-18.845,12.564-21.431C2387.781,1472.2,2370.414,1447.817,2469.073,1407.91Z",
    transform: "translate(-2272.045 -1389.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14022",
    "data-name": "Path 14022",
    d: "M2367.686,1567.839s-11.966,18.172-5.144,40.292l3.079-.827s-2.989-24.364,3.272-36.618S2367.686,1567.839,2367.686,1567.839Z",
    transform: "translate(-2264.514 -1469.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14023",
    "data-name": "Path 14023",
    d: "M2331.967,1695a54.286,54.286,0,0,0,54.286-54.286H2277.682A54.286,54.286,0,0,0,2331.967,1695Z",
    transform: "translate(-2222.339 -1507.994)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14024",
    "data-name": "Path 14024",
    d: "M2352.2,1694.579a54.316,54.316,0,0,1-61.028-53.87h13.486A54.294,54.294,0,0,0,2352.2,1694.579Z",
    transform: "translate(-2229.214 -1507.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14025",
    "data-name": "Path 14025",
    d: "M2386.223,1750.085H2276.153a6.7,6.7,0,0,1,6.7-6.7h96.676a6.7,6.7,0,0,1,6.7,6.7Z",
    transform: "translate(-2221.559 -1560.321)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 111.591,
    height: 1.665,
    transform: "translate(53.558 132.715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.909ca59194e2fb2effac13d116065777.svg";
export { ForwardRef as ReactComponent };